import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a81aa354"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "home-slider__wrapper",
  "data-slider-type": "signUp"
}
const _hoisted_2 = { class: "home-slider" }
const _hoisted_3 = { class: "home-slider-item" }
const _hoisted_4 = {
  class: "home-slider-item-element active",
  "data-link-disabled": true
}
const _hoisted_5 = ["src", "data-orientation", "width", "height"]

import { PromoPageInterface } from '@/types/promoPage.interface';
import { computed } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  props: {
    pageData: null
  },
  setup(__props: any) {

const props = __props as {
  pageData: PromoPageInterface;
}



const store = useStore();
const isPortraitOrientation = computed(
  () => store.getters['platform/isPortraitOrientation']
);

const isMobile = computed(() => store.getters['platform/isMobile']);

const bannerImg = computed(() => {
  if (isMobile.value) {
    return props.pageData.params[0].modal_banner_mobile;
  } else {
    return props.pageData.params[0].modal_banner_desktop;
  }
});

const url = computed((): string => {
  return bannerImg.value?.url;
});

const width = computed(() => {
  return bannerImg.value?.width;
});

const height = computed(() => {
  return bannerImg.value?.height;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            ref: (_value, _refs) => {
              _refs['banner'] = _value
            },
            src: _unref(url),
            class: "home-slider-item-element-img",
            "data-orientation": _unref(isPortraitOrientation) ? 'portrait' : 'landscape',
            "data-slider-type": "signUp",
            alt: "",
            width: _unref(width),
            height: _unref(height)
          }, null, 8, _hoisted_5)
        ])
      ])
    ])
  ]))
}
}

})